<template>
  <div class="content-ambiente">
    
    <h2>Requisitos para consultores</h2>

    <h3>Para Consultores Individuales</h3>
    <ol>
      <li>Solicitud de Inscripción.</li>
      <li>Curriculum Vitae, firmado (no más de cinco hojas).</li>
      <li>Fotocopia autenticada del título Universitario de grado o terciario según corresponda, debidamente
        legalizado y las incumbencias profesionales.</li>
      <li>Fotocopia autenticada de la matrícula profesional.</li>
      <li>Fotocopia certificada de DNI.</li>
      <li>Constancias de antecedentes laborales en estudios ambientales, acreditados por terceros (participación en
        grupos interdisciplinarios de EsIA, diagnóstico ambiental, auditorías ambientales). Por ejemplo: contratos;
        facturas, recibos, órdenes de compra vinculables a los trabajos realizados; carátulas e índices de trabajos
        donde conste autor/es y comitente; certificación de su participación en el trabajo por parte de la empresa,
        organismo contratista o el responsable del estudio.</li>
      <li>Declaración Jurada (con los requisitos y exigencias para la inscripción en el registro).</li>
    </ol>

    <h3>Para Firmas Consultoras</h3>
    <ol>
      <li>Solicitud de Inscripción</li>
      <li>Acreditar la constitución legal de la sociedad, individualizando a su representante legal, copia del
        Estatuto Social con nómina de autoridades.</li>
      <li>Fotocopia autenticada de DNI del responsable legal designado en acta societaria.</li>
      <li>Fotocopia de la constancia de CUIT.</li>
      <li>Listado de los profesionales asignados a cada área temática especificada.</li>
      <li>Curriculum Vitae, firmado (no más de tres hojas), de cada consultor perteneciente a la firma.</li>
      <li>Fotocopia autenticada del título Universitario de grado o terciario según corresponda, debidamente
        legalizado de cada consultor perteneciente a la firma y las incumbencias profesionales.</li>
      <li>Fotocopia autenticada de la matrícula profesional, de cada consultor perteneciente a la firma.</li>
      <li>Fotocopia certificada de DNI, de cada consultor perteneciente a la firma.</li>
      <li>Declaración Jurada (con los requisitos y exigencias para la inscripción en el registro).</li>
      <li>Constancias de antecedentes laborales en estudios ambientales, acreditados por terceros, (estudios de
        impacto ambiental, diagnóstico ambiental). Por ejemplo: facturas, contratos, recibos, órdenes de compra,
        carátulas e índices de trabajos (donde conste autor/es y comitente), certificación de la realización del
        trabajo, por la empresa u organismo contratante. Aquellas firmas que no cuenten con antecedentes laborales
        en la temática, presentar los antecedentes y las acreditaciones correspondientes, de los profesionales
        propuestos por ésta.</li>
    </ol>


    <h3>Para las Universidades como Firmas Consultoras</h3>
    <ol>
      <li>Las Universidades Nacionales (públicas o privadas), para postularse como Firmas Consultoras, deben
        presentar lo especificado en los puntos 1 al 11 del listado de requisitos para Firmas Consultoras, y además:
      </li>
      <li>Copia autenticada de la Resolución Estatutaria de la Universidad.</li>
      <li>Nota de la máxima autoridad de la Universidad autorizando la inscripción de la misma como Firma
        Consultora, en la cual debe constar la nómina de profesionales propuestos para la conformación de la misma,
        firmada en original.</li>
      <li>Documento con la designación del Representante Legal (ya sea por Resolución Estatutaria de la Universidad,
        Nota de la Máxima Autoridad Universitaria, o Designación de la Junta Universitaria) pudiendo desempeñarse
        como tal el rector, el vicerrector o la persona designada (en forma escrita) por alguno de ellos, en
        fotocopia autenticada.</li>
    </ol>

    <h3>Procedimiento</h3>
    <ol>
        <li>Completar la Solicitud de Inscripción adjunta según corresponda</li>
        <li>Completar la Declaración Jurada adjunta</li>
        <li>Realizar el pago de arancel según la categoría de inscripción en Cuenta Fondo de Fomento Ambiental N° 211288 Banco San Juan.</li>
        <ul>
            <li>CBU Bloque 1: 04506009</li>
            <li>CBU Bloque 2: 01800021128812</li>
        </ul>
        <li>Presentar por mesa de entradas todos los requisitos según la categoría de inscripción. La presentación debe realizarse con unidades tributarias correspondientes y con la nota de solicitud por duplicado.</li>
    </ol>
    
    <h3 class="descargas-title">Links de Descarga</h3>
    <CardGridComponent
    columnas="2"
    :data="[
      {
        target: '_blank',
        title: 'Declaración Jurada',
        url: '/files/DECLARACIÓN-JURADA.pdf',
      },
      {
        target: '_blank',
        title: 'Solicitudes de Inscripción',
        url: '/files/SOLICITUDES-DE-INSCRIPCIÓN.pdf',
      }
    ]"
  />
  </div>

</template>

<style scoped>

.descargas-title{
  margin-top: 50px;
}

.content-ambiente{
  padding: 70px 150px !important;
}
h2{
  margin-top: 40px;
}
h3{
  margin-top: 30px;
}

</style>

<script>
import CardGridComponent from "../resources/CardGridComponent"

  export default{
    name: "RequisitosViewComponent",
    components: {CardGridComponent}
  }
</script>